import { useQuery } from '@tanstack/react-query';
import { fetchLeftToPay } from '../services/paymentLinks';
import { agreementKeys } from './agreementKeys';

export function useAgreementLeftToPayQuery(id: string | undefined, elemisAgreementRef: string | null | undefined) {
    return useQuery({
        queryKey: [...agreementKeys.leftToPay(id ?? ''), elemisAgreementRef ?? null],
        queryFn: () => fetchLeftToPay(id!),
        enabled: !!id && elemisAgreementRef !== undefined && elemisAgreementRef !== null,
        staleTime: 0,
        refetchOnWindowFocus: false,
    });
}
